import { ButtonPrimary } from "components/Atoms/Button";
import React from "react";
import InPageEditableFieldWithLabel from "./InPageEditableFieldWithLabel";
import { EditNewFormSection, InPageEditableSectionField } from "./types";

interface Props {
  section: EditNewFormSection
  submit: () => void;
  isSaving?: boolean;
}

export const InnerFormTemplate = (props: Props) => {

  const isFieldHidden = (field: InPageEditableSectionField): boolean => {
    if (field.hidden) return true;

    return false;
  }

  const mappedSection = {
    ...props.section,
    fields: props.section.fields.map((field) => ({
      ...field,
      isEmpty: false,
      render: field.renderEditNew,
      inPageEdit: undefined,
    })),
  }

  const renderFormSectionFields = (fields: Array<InPageEditableSectionField>) => {
    const visibleFields = fields.filter(field => !isFieldHidden(field));
    return <div className="main-section-template-compact-label-grid">
      {visibleFields.map(field => <InPageEditableFieldWithLabel key={field.key} field={field} compact />)}
    </div>
  }

  return <form className="main-section-template-inner-form-wrapper"
    onSubmit={e => {
      e.preventDefault();
      // Stop propagation because we can have a form in a form (e.g. form > modal > form)
      e.stopPropagation();
      props.submit();
    }}
  >
    {renderFormSectionFields(mappedSection.fields)}
    <div className="flex-column gap margin-top-small">
      <div className="flex">
        <div className="grow1" />
        <ButtonPrimary
          htmlType="submit"
          loading={props.isSaving}
          disabled={props.isSaving}
          label={RESX.Buttons.btnSave}
        />
      </div>
    </div>
  </form>
}